@if (isOwnCollection) {
    <div class="flex flex-col sm:flex-row gap-2 justify-center">
        <div class="flex flex-col w-[360px] sm:min-w-[360px] sm:max-w-[720px] gap-2 grow">
            <div class="font-bold border-b border-ponder-light border-opacity-10">
                Collection Export
            </div>
            <!-- Step 1 -->
            <div class="flex flex-col p-2 gap-2 bg-slate-100 rounded shadow">
                <div class="text-sm font-bold">
                    Step 1: Select a game.
                </div>
                <div class="flex flex-row gap-2 flex-wrap text-sm">
                    <button 
                        (click)="onGameSelected(gameTypes.Magic)"
                        class="p-2 bg-slate-50 rounded shadow-sm flex flex-row items-center stroke-ponder-light hover:text-ponder-link hover:cursor-pointer border hover:border-ponder-link"
                        [ngClass]="{ 'text-ponder-link border-ponder-link' : isGameSelected(gameTypes.Magic)}">
                        Magic
                    </button>
                    <!--
                    <button 
                        (click)="onGameSelected(gameTypes.Lorcana)"
                        class="p-2 bg-slate-50 rounded shadow-sm flex flex-row items-center stroke-ponder-light hover:text-ponder-link hover:cursor-pointer border hover:border-ponder-link"
                        [ngClass]="{ 'text-ponder-link border-ponder-link' : isGameSelected(gameTypes.Lorcana)}">
                        Lorcana
                    </button>
                    -->
                </div>
            </div>
            <!-- Step 2 -->
            <div class="flex flex-col p-2 gap-2 bg-slate-100 rounded shadow">
                <div class="text-sm font-bold">
                    Step 2: Select collection format.
                </div>
                <div class="flex flex-row gap-2 flex-wrap text-sm">
                    <button 
                        (click)="onFormatSelected(collectionFormats.Csv)"
                        class="p-2 bg-slate-50 rounded shadow-sm flex flex-row items-center stroke-ponder-light hover:text-ponder-link hover:cursor-pointer border hover:border-ponder-link"
                        [ngClass]="{ 'text-ponder-link border-ponder-link' : isFormatSelected(collectionFormats.Csv)}">
                        CSV (.csv)
                    </button>
                    <button 
                        (click)="onFormatSelected(collectionFormats.UrzaGatherer)"
                        class="p-2 bg-slate-50 rounded shadow-sm flex flex-row items-center stroke-ponder-light hover:text-ponder-link hover:cursor-pointer border hover:border-ponder-link"
                        [ngClass]="{ 'text-ponder-link border-ponder-link' : isFormatSelected(collectionFormats.UrzaGatherer)}">
                        Urza Gatherer (.ugs)
                    </button>
                </div>
            </div>
            <!-- Export -->
            <div class="flex flex-row justify-end">
                <button
                    (click)="onExportClicked()"
                    class="flex flex-row items-center align-middle justify-center text-sm p-2 bg-slate-50 w-[12ch] h-8 rounded shadow-sm stroke-ponder-light hover:text-ponder-link hover:cursor-pointer border border-transparent hover:border-ponder-link disabled:text-slate-400 hover:disabled:border-transparent hover:disabled:cursor-default" 
                    [attr.disabled]="isExporting || oneAndDone || isThrottled ? true : undefined">
                    @if (oneAndDone) {
                        <div>Done</div>
                    } @else if (!isExporting) {
                        <div>Export</div>
                    } @else {
                        <busy-spin [small]="true"></busy-spin>
                    }
                </button>
            </div>
            @if (exportFailure) {
                <div class="rounded border border-red-600 text-red-600 bg-slate-100 text-sm p-2">
                    Collection import failed 😔<br/>
                    {{ failureReason }}
                </div>
            }
            <!-- History -->
            <div class="font-bold border-b border-ponder-light border-opacity-10">
                Export History
            </div>
            <div class="flex flex-col gap-2">
                <export-collection-results></export-collection-results>
            </div>
        </div>
    </div>
} @else {

}
